import React, { useState } from 'react';
import JBButton from '@jbhi-fi/lanyard-ui/components/Button';
import FulfilmentOption, { FulfilmentOptionProps } from '../fulfilment-option/FulfilmentOption';
import ArrowDownSvg from '../../../../../assets/svg/icon-expand-chevron.svg';
import ArrowUpSvg from '../../../../../assets/svg/icon-chevron-up.svg';
import SantizedHTML from '../../common/SantizedHTML';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { styles } from './fulfilmentOptionGroup.css';

export type FulfilmentOptionGroupProps = {
  title: string;
  isDelivery?: boolean;
  isClickAndCollect?: boolean;
  available: boolean;
  options: Array<FulfilmentOptionProps>;
  isWithinRange?: boolean;
  maxDistanceWarning?: string;
};

const FulfilmentOptionGroup = ({
  title,
  isDelivery,
  isClickAndCollect,
  available,
  options,
  isWithinRange,
  maxDistanceWarning,
}: FulfilmentOptionGroupProps): JSX.Element => {
  const [showMore, setShowMore] = useState(false);
  const [activeOptions] = useState(isWithinRange || !maxDistanceWarning ? options?.slice(0, 2) : []);
  const [extraOptions] = useState(isWithinRange || !maxDistanceWarning ? options?.slice(2, 5) : []);
  return (
    <div>
      <CalloutFont as="h2" className={styles.title}>
        {title}
      </CalloutFont>
      {available ? (
        <div>
          {activeOptions.length > 0 &&
            activeOptions.map((option, index) => (
              <FulfilmentOption
                key={index}
                title={option.title}
                serviceImage={option.serviceImage}
                serviceName={option.serviceName}
                experienceName={option.experienceName}
                description={option.description}
                price={option.price}
                isUnavailable={option.isUnavailable}
                storeLink={option.storeLink}
                isClickAndCollect={isClickAndCollect}
                importantMessaging={option.importantMessaging}
              />
            ))}

          {!isWithinRange && Boolean(maxDistanceWarning) ? (
            <SantizedHTML html={maxDistanceWarning} className={styles.alert} />
          ) : null}

          {extraOptions.length > 0 && !showMore ? (
            <div className={styles.iconLink}>
              <JBButton
                type="link"
                label={isDelivery ? 'More delivery options' : 'More stores'}
                onClick={() => setShowMore(true)}
                icon={<ArrowDownSvg />}
                iconPosition="left"
              />
            </div>
          ) : null}

          {extraOptions.length > 0 && showMore
            ? extraOptions.map((option, index) => (
                <FulfilmentOption
                  key={index}
                  title={option.title}
                  serviceImage={option.serviceImage}
                  serviceName={option.serviceName}
                  experienceName={option.experienceName}
                  description={option.description}
                  price={option.price}
                  isUnavailable={option.isUnavailable}
                  storeLink={option.storeLink}
                  isClickAndCollect={isClickAndCollect}
                  importantMessaging={option.importantMessaging}
                />
              ))
            : null}

          {extraOptions.length > 0 && showMore ? (
            <div className={styles.iconLink}>
              <JBButton
                type="link"
                label={isDelivery ? 'Hide delivery options' : 'Hide stores'}
                onClick={() => setShowMore(false)}
                icon={<ArrowUpSvg />}
                iconPosition="left"
              />
            </div>
          ) : null}
        </div>
      ) : (
        <p className={styles.warning}>Unavailable</p>
      )}
    </div>
  );
};

export default FulfilmentOptionGroup;
